/** Alignement vertical pour les vignettes en `object-cover` (valeurs API Prisma). */
export type ServiceItemImageObjectPosition = "TOP" | "CENTER" | "BOTTOM";

export const serviceItemImageObjectPositionClass = (
  position?: ServiceItemImageObjectPosition | null,
): string => {
  switch (position) {
    case "TOP":
      return "object-top";
    case "BOTTOM":
      return "object-bottom";
    default:
      return "object-center";
  }
};
